import React from "react";
import { AlertCircleIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { painPoints } from "../../data/content";
export function PainPointsSection() {
  return <section className="bg-paper px-4 py-16 sm:py-24" data-id="element-277" data-mp="1bmo57581vn2v">
      <div className="mx-auto max-w-5xl" data-id="element-278" data-mp="1glip6ahr7hok">
        <SectionHeading tone="light" kicker="Does any of this sound familiar?" title="If you've experienced even one of these situations, I created this system for you." data-id="element-279" data-mp="1gk7io2wxbvtr" />

        <ul className="mt-12 grid gap-x-10 gap-y-8 md:grid-cols-2" data-id="element-280" data-mp="nyedxns2i74c">
          {painPoints.map(p => <li key={p.title} className="flex gap-4 border-l-4 border-alert pl-4" data-id="element-281" data-mp="sxrbp3kh8ylp">
              <div data-id="element-282" data-mp="xvsudndzqvwn">
                <h3 className="flex items-start gap-2 text-xl font-extrabold leading-snug text-navy" data-id="element-283" data-mp="xs51mqgdediz">
                  <AlertCircleIcon className="mt-1 h-5 w-5 shrink-0 text-alert" aria-hidden="true" data-id="element-284" data-mp="299o8cst5syma" />
                  {p.title}
                </h3>
                <p className="mt-2 text-[17px] leading-relaxed text-navy/75" data-id="element-285" data-mp="2r1q6npjp0iq9">{p.text}</p>
              </div>
            </li>)}
        </ul>

        <div className="mt-14 rounded-3xl bg-navy p-6 text-center sm:p-10" data-id="element-286" data-mp="2i2cugp46pg1u">
          <h3 className="font-display text-2xl font-extrabold text-white sm:text-3xl" data-id="element-287" data-mp="2i4fttzr88lj8">
            And here's what I want you to understand…
          </h3>
          <p className="mx-auto mt-4 max-w-2xl text-lg leading-relaxed text-white/80" data-id="element-288" data-mp="284fa4cpg43ei">
            The answer isn't another lengthy course or another collection of textbooks. What makes a practical difference is
            having the right information <strong className="text-brand" data-id="element-289" data-mp="1z9r24eshk7m0">organized in a format you can actually use</strong>{" "}
            when reviewing a case.
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-lg leading-relaxed text-white/80" data-id="element-290" data-mp="1pe7ba6ss3z44">
            That's why I designed The ClinCheck Blueprint around visual frameworks, structured workflows, and practical review
            tools.
          </p>
        </div>

        <div className="mt-10" data-id="element-291" data-mp="1atbj7mgysa6s">
          <CTAButton label="I want the Blueprint system" data-id="element-292" data-mp="1fql6avgvs9rg" />
        </div>
      </div>
    </section>;
}